<template>
    <!-- START  NAVBAR -->
    <nav
        :class="[
            'navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-light',
        ]"
        id="navbar"
    >
        <div class="container xs:tw-w-full">
            <!-- LOGO -->
            <a class="navbar-brand logo text-uppercase py-0" href="/">
                <img
                    :src="require('../../../assets/logos/512x512.png')"
                    class="logo-light tw-h-[60px] xs:tw-h-[40px]"
                    alt="logo"
                />
                <img
                    :src="require('../../../assets/logos/512x512.png')"
                    class="logo-dark tw-h-[60px] xs:tw-h-[40px]"
                    alt="logo"
                />
            </a>

            <button
                class="navbar-toggler"
                type="button"
                @click="isCollapsed = !isCollapsed"
            >
                <span class="mdi mdi-menu"></span>
            </button>

            <div
                :class="[
                    'collapse navbar-collapse xs:tw-overflow-y-auto xs:tw-overflow-x-hidden xs:tw-max-h-[300px]',
                    isCollapsed ? 'show' : '',
                ]"
            >
                <ul class="navbar-nav ms-auto" id="navbar-navlist">
                    <li class="nav-item" v-if="!$page.props.is_login">
                        <Link class="nav-link" href="/#home">{{
                            __("chat.home")
                        }}</Link>
                    </li>
                    <li class="nav-item" v-if="!$page.props.is_login">
                        <Link class="nav-link" href="/#whyuse">{{
                            __("chat.why_use")
                        }}</Link>
                    </li>
                    <li class="nav-item" v-if="!$page.props.is_login">
                        <Link class="nav-link" href="/#features">{{
                            __("chat.features")
                        }}</Link>
                    </li>
                    <li class="nav-item" v-if="!$page.props.is_login">
                        <Link class="nav-link" href="/#download">{{
                            __("chat.download")
                        }}</Link>
                    </li>
                    <li class="nav-item" v-if="!$page.props.is_login">
                        <Link class="nav-link" href="/#contact">{{
                            __("chat.contact")
                        }}</Link>
                    </li>
                    <li
                        :class="[
                            'nav-item',
                            $page.props.is_login
                                ? 'tw-block'
                                : 'tw-hidden xs:tw-block',
                        ]"
                        v-for="(page, key) in $page.props.pages"
                        :key="key"
                    >
                        <Link class="nav-link" :href="'/page/' + page.slug">{{
                            translate(page.title_en, page.title_mm)
                        }}</Link>
                    </li>
                    <li
                        :class="[
                            'nav-item tw-flex tw-items-center',
                            $page.props.is_login ? 'tw-hidden' : 'xs:tw-hidden',
                        ]"
                    >
                        <div class="dropdown">
                            <a
                                class=""
                                data-bs-toggle="dropdown"
                                @click.prevent=""
                                href="#"
                                ><div
                                    class="tw-w-8 tw-h-8 tw-flex tw-justify-center tw-items-center tw-bg-slate-200/50 tw-shadow-sm tw-rounded-full"
                                >
                                    <i
                                        class="fas fa-ellipsis-h tw-text-lg"
                                    ></i></div
                            ></a>
                            <ul class="dropdown-menu tw-left-auto tw-right-0">
                                <li
                                    v-for="(page, key) in $page.props.pages"
                                    :key="key"
                                >
                                    <Link
                                        class="dropdown-item"
                                        :href="'/page/' + page.slug"
                                        >{{
                                            translate(
                                                page.title_en,
                                                page.title_mm
                                            )
                                        }}</Link
                                    >
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <!-- <div
                    class="ms-auto tw-flex tw-items-center tw-px-[22px] tw-py-[8px]"
                >
                    <span
                        @click="changeLanguage('en')"
                        :class="[
                            'tw-cursor-pointer tw-text-sm',
                            locale == 'en'
                                ? 'tw-text-main-color'
                                : 'tw-text-black',
                        ]"
                        v-btooltip:bottom="'English'"
                        >EN</span
                    >
                    <span class="tw-text-[14px] tw-px-1">|</span>
                    <span
                        v-btooltip:bottom="'Myanmar'"
                        @click="changeLanguage('mm')"
                        :class="[
                            'tw-cursor-pointer tw-text-sm',
                            locale == 'mm'
                                ? 'tw-text-main-color'
                                : 'tw-text-black',
                        ]"
                        >MM</span
                    >
                </div> -->
            </div>
        </div>
    </nav>
    <!-- END NAVBAR -->
</template>
<script>
import { Link } from "@inertiajs/vue2";

export default {
    components: { Link },
    data() {
        return {
            locale: window._locale,
            isCollapsed: false,
        };
    },
    mounted() {},
    methods: {
        changeLanguage(lang) {
            axios
                .post(`${process.env.MIX_APP_URL}/change-language`, {
                    lang,
                })
                .then(({ data }) => {
                    if (data.result == 1) {
                        window.location.reload();
                    } else {
                        Vue.$toast.warning(data.message);
                    }
                })
                .catch(() => {
                    Vue.$toast.error(this.__("chat.something_wrong"));
                });
        },
    },
};
</script>
